import { useState } from "react";
import { Loader2, LogIn } from "lucide-react";
import { Input } from "../components/ui/input";
import { useAuth, formatApiError } from "../lib/auth";
import { useTheme } from "../hooks/useTheme";

export default function LoginPage() {
  const { login } = useAuth();
  const [theme] = useTheme();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="login-page">
      <form onSubmit={submit} className="panel w-full max-w-sm p-8 fade-up">
        <img src={theme === "dark" ? "/brand/ep-group-white.png" : "/brand/ep-group-dark.png"} alt="EP Group" className="h-10 w-auto" />
        <h1 className="font-display text-2xl font-bold text-slate-100 mt-6">Warehouse Activity Monitor</h1>
        <p className="text-sm text-slate-400 mt-1 mb-6">Sign in to continue</p>
        <label className="label-mono">Email</label>
        <Input data-testid="login-email-input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 mb-4 h-10 bg-[#0B0F19] border-slate-700 text-slate-100" />
        <label className="label-mono">Password</label>
        <Input data-testid="login-password-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-10 bg-[#0B0F19] border-slate-700 text-slate-100" />
        {error && <p className="text-sm text-rose-400 mt-4" data-testid="login-error">{error}</p>}
        <button data-testid="login-submit-button" disabled={busy} className="mt-6 w-full h-10 inline-flex items-center justify-center gap-2 rounded-md bg-ep hover:bg-ep-hover text-white text-sm font-medium disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />} Sign in
        </button>
      </form>
    </div>
  );
}
